import React from 'react';
import { Typography } from '../../components';
import { useTranslations } from '../../contexts/translation.context';
import IcBlock from '../CTA-decor.jpg';
import IcTg2 from '../tg-2.svg';

export function NewsBlock() {
  const { t } = useTranslations();

  return (
    <div className="relative rounded-3.5 flex flex-col justify-between overflow-hidden min-h-[14.3125rem] md:min-h-[18rem]">
      <div className="absolute inset-x-0">
        <img
          className="rounded-3.5 md:min-w-[26.9375rem] w-full h-full md:h-[18rem]"
          src={IcBlock}
          alt=""
        />
      </div>
      <div className="p-4 px-3.5 md:p-6 flex flex-col justify-between h-full z-[2] flex-1">
        <div className="mb-4">
          <span className="block text-xl font-medium text-white mb-2">
            {t('dashboard.newsTitle')}
          </span>
          <span className="block text-base font-normal text-white/80">
            {t('dashboard.newsDescription')}
          </span>
        </div>
        <div className="flex items-center gap-2 mb-2"></div>
        <div className="flex flex-col gap-1 md:px-0 pl-1.5">
          <a
            href="https://t.me/onlyu_news"
            target="_blank"
            rel="noopener noreferrer"
            className="flex gap-2.5 items-center"
          >
            <img src={IcTg2} alt="Telegram" className="w-[1.375rem] h-[1.375rem]" />
            <Typography variant="h6" className="text-white mt-[-.25rem]">
              @onlyu_news
            </Typography>
          </a>
          <Typography variant="body2" className="text-white/80">
            {t('dashboard.telegramDescription')}
          </Typography>
        </div>
      </div>
    </div>
  );
}
